import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtAdminTargetList } from 'containers';
import { AdminTargetMenu, AdminPageTitle, AdminPageTemplate } from 'components';

class CtAdminUser extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <AdminPageTemplate className="table">
        <AdminPageTitle
          type="table"
          title={defineMessages(formatMessage({ id: 'CtAdminTarget_1', defaultMessage: '대상자' }))}>
          <AdminTargetMenu />
        </AdminPageTitle>
        <CtAdminTargetList />
      </AdminPageTemplate>
    );
  }
}

CtAdminUser.propTypes = {};
CtAdminUser.defaultProps = {};

export default injectIntl(CtAdminUser);



// WEBPACK FOOTER //
// ./src/script/containers/admin/target/CtAdminTarget.js